import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './global.css';
import { Modal } from '@efast_public/fjd-component-library';
const container = document.getElementById('app');
const root = createRoot(container!);

Modal.setAppElement('#app');

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
